import { create } from "zustand";

import type { LobbyView, PlayerEvent, PlayerView, SessionEstablished } from "@pactfront/contracts";

interface ClientState {
  connected: boolean;
  session: SessionEstablished | null;
  lobby: LobbyView | null;
  view: PlayerView | null;
  events: PlayerEvent[];
  notice: ClientNotice | null;
  setConnected: (connected: boolean) => void;
  setSession: (session: SessionEstablished) => void;
  setLobby: (lobby: LobbyView) => void;
  setView: (view: PlayerView, events?: PlayerEvent[]) => void;
  addEvents: (events: PlayerEvent[]) => void;
  showNotice: (kind: ClientNotice["kind"], messageKey: string, params?: NoticeParams) => void;
  clearNotice: () => void;
  reset: () => void;
}

type NoticeParams = Record<string, string | number | boolean>;

export interface ClientNotice {
  id: number;
  kind: "success" | "error";
  messageKey: string;
  params?: NoticeParams;
}

export const useClientStore = create<ClientState>((set) => ({
  connected: false,
  session: null,
  lobby: null,
  view: null,
  events: [],
  notice: null,
  setConnected: (connected) => set({ connected }),
  setSession: (session) => set({ session }),
  setLobby: (lobby) => set({ lobby }),
  setView: (view, events = []) =>
    set((state) => ({
      view,
      ...(events.length === 0 ? {} : { events: [...state.events, ...events].slice(-20) }),
    })),
  addEvents: (events) => set((state) => ({ events: [...state.events, ...events].slice(-20) })),
  showNotice: (kind, messageKey, params) =>
    set({
      notice: { id: Date.now(), kind, messageKey, ...(params === undefined ? {} : { params }) },
    }),
  clearNotice: () => set({ notice: null }),
  reset: () => set({ session: null, lobby: null, view: null, events: [], notice: null }),
}));
